<nf-form-control label="Date Range">
  <nf-daterange
    id="dateRange"
    [ngModel]="dateRange"
    (ngModelChange)="onModelChange($event)"
    [beginDateRequired]="false"
    [endDateRequired]="false"
  ></nf-daterange>
</nf-form-control>
